module.exports = __webpack_public_path__ + "static/media/customer_edit.24d98330.svg";